import React from 'react';
import Header from './components/Header';
import FormPage from './components/FormPage';

function App() {
  return (
    <>
      <Header />
      <FormPage />
    </>
  );
}

export default App;
